export interface AppointmentHistory {
  // will be deprecated soon
  uuid: string
  name: string
  patient_uuid: string
  branch_uuid: string
  branch_name: string
  status: string
  status_text: string
  mobile: string
  appoint_date: string
  appoint_time: string
  description: string
  is_seen: boolean
  staff_name: string
  interests: string[]
  deposit_types: string[]
  remind_method: string
  doctor_name: string
  nurse_name: string
  postpone_count: number
  create_by: 'clinic' | 'patient'
}

export interface AppointmentHistoryFormatted extends AppointmentHistory {
  expire_date: Date
}

export interface AppointmentData {
  data: AppointmentPatient
  is_limit: boolean | null
}

export interface AppointmentPatient {
  patient_code: string
  fname: string
  fname_en: null
  lname: string
  lname_en: null
  birthdate: Date
  mobile: string
  email: null
}
export interface AppointmentBranchGroupMembership {
  id: number
  name: string
  group_order: number
  branch_order: number
}
export interface AppointmentBranch {
  text: string
  show_name: string
  show_name_en?: string
  show_name_cn?: string
  uuid: string
  map_latitude: number | null
  map_longitude: number | null
  display_order: number
  groups: AppointmentBranchGroupMembership[]
}
export interface AppointmentSetting {
  appoint_liff_start_day: number
  appoint_liff_end_day: number
  appoint_liff_hiding_doctor: boolean
  appoint_liff_warning_msg: string
  appoint_liff_push_msg: string
  appoint_liff_select_doctor_without_workhours: boolean
}

export interface DoctorBreak {
  id: number
  start: string
  end: string
}

export interface DoctorWorkSchedule {
  id: number
  doctor_id: number
  doctor_name: string
  doctor_fname: string
  doctor_lname: string
  doctor_fname_en?: string | null
  start: string
  end: string
  breaks: DoctorBreak[]
}

export interface ICreateAppointment {
  name: string
  mobile: string | null
  email: string | null
  branch: string | null
  doctor: string | null
  date: string
  time: string[]
  note: string
  // id ของบริการที่สนใจ (DepositType.id) - บังคับตอนสร้างนัด ส่วนเลื่อนนัดไม่ส่ง (backend คงบริการของนัดเดิม)
  deposit_type?: number | null
  interest_tags: number[]
}

export interface RecentAppointment {
  uuid: string // appointment_uuid
  branch_name: string
  branch_name_en?: string
  branch_name_cn?: string
  branch_place?: string
  branch_map_link?: string
  branch_uuid: string
  appoint_date: string
  appoint_time: string
  patient_uuid: string
}

export enum AppointmentEventType {
  VISIT_APPOINTMENT = 'visit',
  CREATE_APPOINTMENT = 'create',
  CANCEL_APPOINTMENT = 'cancel',
  POSTPONE_APPOINTMENT = 'postpone',
}

export interface InterestTag {
  id: number
  name: string
}

/**
 * บริการที่สนใจที่ LINE OA เปิดให้เลือก จาก GET /api/v1/crm/line-app/p/appointment/service/ (LMP-7840)
 * คลินิกตั้งเอง (เพิ่ม / แก้ชื่อ / ถอด) ที่ POS - รายการและลำดับต่างกันได้ราย LINE OA ห้ามอ้างอิงด้วยชื่อหรือ id ตายตัว
 */
export interface DepositType {
  // id ของ master ระดับคลินิก (ไม่ใช่ของ LINE OA) - ส่งกลับเป็น deposit_type ตอนสร้างนัด
  id: number
  // ชื่อไทย = ชื่อที่คลินิกเห็นใน POS - ใช้ต่อท้าย note ทุกภาษา
  name: string
  // คำแปลราย LINE OA - backend fallback ให้แล้ว (en -> ไทย, cn -> en -> ไทย)
  name_en: string
  name_cn: string
  // หัตถการใต้บริการนี้ เรียงตามที่ต้องแสดง - ว่าง = ไม่มีช่องเลือกหัตถการ
  interest_tags: InterestTag[]
}
export interface GroupedBranch {
  name: string
  branches: AppointmentBranch[]
}
